import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-researchunit',
    templateUrl: './researchunit.component.html',
    styleUrls: ['./researchunit.component.scss']
})
export class ResearchunitComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI’s Research Policy: Guiding Innovation and Ethics');
        this.meta.updateTag({
            name: 'description',
            content: `Discover ARNI’s Research Policy, ensuring ethical practices, integrity, and excellence in all research activities, fostering impactful and responsible innovation.`
        });
    }

}
